import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	resizer: {
		id: 'flex-resizer.handle.resizer',
		defaultMessage: 'Resize',
		description: 'This is a resizer to drag the view layout',
	},
});
